import { render, staticRenderFns } from "./ControlTeam.vue?vue&type=template&id=396acb79&"
import script from "./ControlTeam.vue?vue&type=script&lang=js&"
export * from "./ControlTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports